import AnimationRoadmap from "./Images/AnimationRoadmap.png";
import TypographyRoadmap from "./Images/TypographyRoadmap.png";
import IllustrationRoadmap from "./Images/IllustrationRoadmap.png";
import WebRoadmap from "./Images/WebRoadmap.png";
import Design3DRoadmap from "./Images/Design3DRoadmap.png";
import PrinciplesImg from "./Images/image-1.png";
import ToolsImg from "./Images/image-3.png";
import TechniquesImg from "./Images/image-2.png";
import TypographyPrinciplesImg from "./Images/TypographyPrinciples.jpg";
import TypographyToolsImg from "./Images/TypographyTools.png";
import TypographyTechniquesImg from "./Images/TypographyTechniques.png";
import IllustrationPrinciplesImg from "./Images/IllustrationPrinciples.png";
import IllustrationToolsImg from "./Images/IllustrationTools.png";
import IllustrationTechniquesImg from "./Images/IllustrationTechniques.png";
import WebPrinciplesImg from "./Images/WebPrinciples.png";
import WebToolsImg from "./Images/WebTools.png";
import WebTechniquesImg from "./Images/WebTechniques.png";
import Design3DPrinciplesImg from "./Images/Design3DPrinciples.png";
import Design3DToolsImg from "./Images/Design3DTools.png";
import Design3DTechniquesImg from "./Images/Design3DTechniques.png";

export const roadmapData = {
  animation: {
    title: "2D Animation Roadmap",
    image: AnimationRoadmap,
    description:
      "Welcome to the Animation Roadmap! This guide will take you through the essentials of animation, from basic principles to advanced techniques. You’ll learn to create captivating animations, whether you’re interested in 2D, 3D, or stop-motion. Each section includes recommended tools and sources of inspiration to help you along your journey.",
    sections: [
      {
        title: "1. Basics of Animation",
        content: [
          {
            title: "Principles of Animation",
            description:
              "Learn the 12 principles of animation, such as Squash and Stretch, Anticipation, Staging, and more. These principles will help you create more dynamic and believable animations.",
          },
          {
            title: "Frame Rate and Timing",
            description:
              "Understand how the frame rate affects the smoothness of your animation and how timing can influence the perception of movement.",
          },
          {
            title: "Storyboarding",
            description:
              "Discover the importance of storyboarding in planning out your animations, ensuring a coherent and engaging story.",
          },
        ],
        image: PrinciplesImg,
      },
      {
        title: "2. Tools",
        content: [
          {
            title: "Adobe Creative Cloud",
            description: "Adobe Animate or After Effects - Cost: $19 per month",
          },
          {
            title: "Procreate Dream",
            description: "(iOS only) - Cost: $22 (One-time Purchase)",
          },
          {
            title: "Pencil2D",
            description: "Cost: Free",
          },
        ],
        image: ToolsImg,
      },
      {
        title: "3. Animation Techniques",
        content: [
          {
            title: "Character Design and Rigging",
            description:
              "Learn how to create compelling character designs and rig them for smooth animation.",
          },
          {
            title: "Keyframes and In-betweens",
            description:
              "Understand the importance of keyframes in defining motion and how to create in-between frames for fluid transitions.",
          },
          {
            title: "Lip Sync and Facial Expressions",
            description:
              "Master the techniques for syncing lip movements to dialogue and animating expressive facial features.",
          },
        ],
        image: TechniquesImg,
      },
    ],
  },
  typography: {
    title: "Typography Roadmap",
    image: TypographyRoadmap,
    description:
      "Welcome to the Typography Roadmap! This guide will take you through the essentials of typography, from basic principles to advanced techniques. You’ll learn to create captivating typography, whether you’re interested in print or digital media. Each section includes recommended tools and sources of inspiration to help you along your journey.",
    sections: [
      {
        title: "1. Basics of Typography",
        content: [
          {
            title: "Principles of Typography",
            description:
              "Learn the key principles of typography, such as alignment, hierarchy, and spacing. These principles will help you create more readable and aesthetically pleasing text.",
          },
          {
            title: "Typefaces and Fonts",
            description:
              "Understand the differences between typefaces and fonts, and how to choose the right ones for your project.",
          },
          {
            title: "Text Composition",
            description:
              "Discover the importance of text composition in creating a visually appealing and coherent design.",
          },
        ],
        image: TypographyPrinciplesImg,
      },
      {
        title: "2. Tools",
        content: [
          {
            title: "Adobe Creative Cloud",
            description: "Adobe Illustrator or InDesign - Cost: $19 per month",
          },
          {
            title: "Google Fonts",
            description: "Free library of fonts",
          },
          {
            title: "FontSquirrel",
            description: "Free fonts for commercial use",
          },
        ],
        image: TypographyToolsImg,
      },
      {
        title: "3. Typography Techniques",
        content: [
          {
            title: "Kerning and Leading",
            description:
              "Learn how to adjust the space between characters and lines to improve readability and visual appeal.",
          },
          {
            title: "Responsive Typography",
            description:
              "Understand how to create typography that looks great on all devices, from mobile to desktop.",
          },
          {
            title: "Advanced Text Effects",
            description:
              "Master techniques for creating eye-catching text effects, such as shadows, gradients, and textures.",
          },
        ],
        image: TypographyTechniquesImg,
      },
    ],
  },
  illustration: {
    title: "Illustration Roadmap",
    image: IllustrationRoadmap,
    description:
      "Welcome to the Illustration Roadmap! This guide will take you through the essentials of illustration, from basic principles to advanced techniques. You’ll learn to create captivating illustrations, whether you’re interested in traditional or digital media. Each section includes recommended tools and sources of inspiration to help you along your journey.",
    sections: [
      {
        title: "1. Basics of Illustration",
        content: [
          {
            title: "Principles of Illustration",
            description:
              "Learn the key principles of illustration, such as composition, perspective, and color theory. These principles will help you create more engaging and visually appealing illustrations.",
          },
          {
            title: "Sketching Techniques",
            description:
              "Understand different sketching techniques and how to apply them in your work.",
          },
          {
            title: "Character Design",
            description:
              "Discover the importance of character design and how to create memorable and dynamic characters.",
          },
        ],
        image: IllustrationPrinciplesImg,
      },
      {
        title: "2. Tools",
        content: [
          {
            title: "Adobe Creative Cloud",
            description: "Adobe Photoshop or Illustrator - Cost: $19 per month",
          },
          {
            title: "Procreate",
            description: "(iOS only) - Cost: $9.99 (One-time Purchase)",
          },
          {
            title: "Krita",
            description: "Cost: Free",
          },
        ],
        image: IllustrationToolsImg,
      },
      {
        title: "3. Illustration Techniques",
        content: [
          {
            title: "Digital Painting",
            description:
              "Learn how to use digital painting techniques to create stunning illustrations.",
          },
          {
            title: "Inking and Coloring",
            description:
              "Understand the process of inking and coloring your illustrations to bring them to life.",
          },
          {
            title: "Storytelling",
            description:
              "Master the art of visual storytelling to create illustrations that tell a story and engage the audience.",
          },
        ],
        image: IllustrationTechniquesImg,
      },
    ],
  },
  web: {
    title: "Web Development Roadmap",
    image: WebRoadmap,
    description:
      "Welcome to the Web Development Roadmap! This guide will take you through the essentials of web development, from basic principles to advanced techniques. You’ll learn to create responsive and dynamic websites, whether you're interested in front-end or back-end development. Each section includes recommended tools and sources of inspiration to help you along your journey.",
    sections: [
      {
        title: "1. Basics of Web Development",
        content: [
          {
            title: "HTML & CSS",
            description:
              "Learn the fundamentals of HTML and CSS to create static web pages.",
          },
          {
            title: "JavaScript",
            description:
              "Understand the basics of JavaScript to add interactivity to your web pages.",
          },
          {
            title: "Responsive Design",
            description:
              "Discover the principles of responsive design to create web pages that look great on all devices.",
          },
        ],
        image: WebPrinciplesImg,
      },
      {
        title: "2. Tools",
        content: [
          {
            title: "Code Editors",
            description:
              "Popular code editors like VS Code, Sublime Text, and Atom.",
          },
          {
            title: "Version Control",
            description: "Learn Git for version control and collaboration.",
          },
          {
            title: "CSS Frameworks",
            description:
              "Explore CSS frameworks like Bootstrap and Tailwind CSS.",
          },
        ],
        image: WebToolsImg,
      },
      {
        title: "3. Advanced Techniques",
        content: [
          {
            title: "JavaScript Frameworks",
            description:
              "Learn popular JavaScript frameworks like React, Angular, and Vue.",
          },
          {
            title: "Backend Development",
            description:
              "Understand backend development with Node.js, Express, and databases.",
          },
          {
            title: "Deployment",
            description:
              "Master the process of deploying web applications using platforms like Netlify, Vercel, and Heroku.",
          },
        ],
        image: WebTechniquesImg,
      },
    ],
  },
  design: {
    title: "3D Design Roadmap",
    image: Design3DRoadmap,
    description:
      "Welcome to the 3D Design Roadmap! This guide will take you through the essentials of 3D design, from basic principles to advanced techniques. You’ll learn to create stunning 3D models, whether you're interested in animation, game design, or product visualization. Each section includes recommended tools and sources of inspiration to help you along your journey.",
    sections: [
      {
        title: "1. Basics of 3D Design",
        content: [
          {
            title: "3D Modeling",
            description:
              "Learn the basics of 3D modeling to create simple 3D objects.",
          },
          {
            title: "Texturing",
            description:
              "Understand the process of adding textures to your 3D models.",
          },
          {
            title: "Rendering",
            description:
              "Discover the principles of rendering to create photorealistic images of your 3D models.",
          },
        ],
        image: Design3DPrinciplesImg,
      },
      {
        title: "2. Tools",
        content: [
          {
            title: "Blender",
            description: "A powerful and free 3D modeling software.",
          },
          {
            title: "ZBrush",
            description:
              "An advanced tool for sculpting high-resolution 3D models.",
          },
          {
            title: "Substance Painter",
            description:
              "A tool for painting textures directly onto your 3D models.",
          },
        ],
        image: Design3DToolsImg,
      },
      {
        title: "3. Advanced Techniques",
        content: [
          {
            title: "Character Modeling",
            description:
              "Learn how to model detailed and realistic 3D characters.",
          },
          {
            title: "Animation",
            description:
              "Understand the basics of 3D animation to bring your models to life.",
          },
          {
            title: "Game Design",
            description:
              "Master the techniques for creating 3D assets for games.",
          },
        ],
        image: Design3DTechniquesImg,
      },
    ],
  },
};
